// extracted by mini-css-extract-plugin
export var cancelButton = "_lr-5";
export var content = "_lr-3";
export var createButton = "_lr-6";
export var drawerContainer = "_lr-0";
export var footer = "_lr-2";
export var header = "_lr-1";
export var orderFormColumn = "_lr-4";